export default __webpack_public_path__ + "static/louis-abraham-ec5315e2c61f4382eb51727fae836691.png";